
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  standalone: false,
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  private _router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  ngOnInit(): void {
    
  }

  public login(): void
  {
    Swal.fire({
      title: 'Esta es una simulación del Login',
      text: 'Deseas ir a componente principal?.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, vamos.',
      cancelButtonText: 'No, quedarme aqui',
    }).then((result) => {
      if (result.value) {
        Swal.fire('Vamos!', 'Seras redirigido al componente principal', 'success');
        this._router.navigate(['/dashboard'], { replaceUrl: true });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Entendido', 'Nos quedaremos aqui, deberas refrescar la pagina de nuevo.)', 'error');
      }
    });
  }
}

